export default __webpack_public_path__ + "static/media/courseLanding-ransomware.588e3676.png";